module.exports = __webpack_public_path__ + "static/LAW OF DOMESTIC ARBITRATION-03201442130442b2cf4be3af1f16ffd1.png";